<template>
  <page>
    <div>
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-text-field v-model="filters.paytType" :label="labels.paytType" :error-messages="errors.collect('paytType')" data-vv-name="paytType" :data-vv-as="labels.paytType" v-validate="'name|max:8'"></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.paytTypeDesc" :label="labels.paytTypeDesc" :error-messages="errors.collect('paytTypeDesc')" data-vv-name="paytTypeDesc" :data-vv-as="labels.paytTypeDesc" v-validate="'name|max:40'"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex md6>
                        <v-checkbox v-model="filters.appGstdit" :label="labels.appGstdit" :error-messages="errors.collect('appGstdit')" data-vv-name="appGstdit" :data-vv-as="labels.appGstdit"></v-checkbox>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field v-model="filters.gstUseStat" :label="labels.gstUseStat" :error-messages="errors.collect('gstUseStat')" data-vv-name="gstUseStat" :data-vv-as="labels.gstUseStat" v-validate="'name|max:1'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew()">
            New Payment Type
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.paytType }}</td>
                <td>{{ row.item.paytTypeDesc }}</td>
                <td>{{ row.item.appGstdit }}</td>
                <td>{{ row.item.gstUseStat }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item.paytType)" query @query="doQuery(row.item.paytType)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Claims Payment Type?
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Payment Types', value: 'paytType' },
        { text: 'Description', value: 'paytTypeDesc' },
        { text: 'Apply GST Deemed Input Tax', value: 'appGstdit' },
        { text: 'GST Usage Status', value: 'gstUseStat' },
        TableConst.tableActionHeader
      ],
      labels: {
        paytType: 'Payment Types',
        paytTypeDesc: 'Description',
        appGstdit: 'Apply GST Deemed Input Tax',
        gstUseStat: 'GST Usage Status'
      },
      filters: {
        paytType: undefined,
        paytTypeDesc: undefined,
        appGstdit: undefined,
        gstUseStat: undefined
      },
      sideFunction: [],
      totalItems: 0,
      selectedPaytType: undefined,
      deletePaytType: undefined,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.getClmPaytTypeList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                if (datamap.appGstdit === false) {
                  datamap.appGstdit = 'No'
                } else if (datamap.appGstdit === true) {
                  datamap.appGstdit = 'Yes'
                } else {
                  datamap.appGstdit = '-'
                }
                const convertList = {
                  paytType: datamap.paytType,
                  paytTypeDesc: datamap.paytTypeDesc,
                  gstUseStat: datamap.gstUseStat,
                  appGstdit: datamap.appGstdit
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.paytType = null
      this.filters.paytTypeDesc = null
      this.filters.appGstdit = null
      this.filters.gstUseStat = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doReview(paytType) {
      this.$router.push({ name: 'clmPaytTypeReview', params: { paytType: paytType, clmPaytTypeMode: 'Review' } })
    },
    doQuery(paytType) {
      this.$router.push({ name: 'clmPaytTypeReview', params: { paytType: paytType, clmPaytTypeMode: 'Query' } })
    },
    doNew() {
      this.$router.push({ name: 'clmPaytTypeReview', params: { paytType: 'new', clmPaytTypeMode: 'New' } })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPaytType = data
        this.deletePaytType = data.paytType
      }
    },
    async doRemove() {
      const apiURI = this.menu.deleteClmPaytType
      if (apiURI) {
        const appGstdit = this.selectedPaytType.appGstdit
        if (appGstdit === 'No') {
          this.selectedPaytType.appGstdit = false
        } else if (appGstdit === 'Yes') {
          this.selectedPaytType.appGstdit = true
        } else {
          this.selectedPaytType.appGstdit = null
        }
        const expand = this.selectedPaytType
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.clmPaytTypeParam.menu
    }
  },
  mounted() {
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
